import FloatingMenu, {
  MenuBody,
} from "components/ui/FloatingMenu/FloatingMenu";
import Link from "next/link";
import dynamic from "next/dynamic";
const DynamicFeaturedDestinations = dynamic(
  () =>
    import(
      "components/DestinationPresentation/DynamicFeaturedDestinations/DynamicFeaturedDestinations"
    )
);

import { regions as R } from "lib/data";

import styles from "./Menu.module.scss";

export default function DestinationHeaderMenu({
  data,
  show,
  featuredDestinations,
}) {
  const regions = R.sort((a, b) => a?.regionName?.localeCompare(b?.regionName));

  return (
    <FloatingMenu
      show={show}
      styling={{
        top: "95%",
        right: "-516%",
      }}
    >
      <MenuBody style={{ width: "950px" }}>
        <div>
          <h2 className={`${styles.regionListHeading}`}>Regions</h2>
          <ul className={`${styles.regionList}`}>
            <li className={` ${styles.regionListItem} `}>
              <h5 className={`${styles.regionHeading}`}>
                <Link
                  href={`/explore-travel-destinations`}
                  aria-label={`destinations-link`}
                  className={`${styles.regionLink}`}
                >
                  All
                </Link>
              </h5>
            </li>
            {regions?.map((region, index) => (
              <li key={index} className={`${styles.regionListItem}`}>
                <h5 className={`${styles.regionHeading}`}>
                  <Link
                    href={`/destinations/${region?.region}`}
                    className={`${styles.regionLink}`}
                  >
                    {region?.regionName}
                  </Link>
                </h5>
              </li>
            ))}
          </ul>
        </div>
        <DynamicFeaturedDestinations
          featuredDestinations={featuredDestinations}
        />
      </MenuBody>
    </FloatingMenu>
  );
}
